import React from "react";

const Checkbox = ({ id, name, checked, label, className = "", onChange = () => {}, disabled = false }) => {
  return (
    <label className={`flex items-center space-x-2 cursor-pointer  ${className}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className={`w-4 h-4 text-primary  border-[#D9D9D9] rounded-sm focus:ring-0 ${disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}  `}
        disabled={disabled}
      />
      {label && <span className="text-[#383838] text-sm">{label}</span>}
    </label>
  );
};

export default Checkbox;
